import * as yup from "yup";
import { selectOptionSchema } from "forms/schemas";

export const addFarmSchema = yup
  .object({
    farm: selectOptionSchema.required("Farm is required"),
  })
  .required();
